export default __webpack_public_path__ + "static/media/Group485@2x.3334f104.png";